import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

// Subtle bottom-of-page "turn the page" link into the next chapter of the story.
export const NextChapter = ({ to, label }) => (
  <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 md:pt-20 pb-16 md:pb-20 flex justify-center">
    <Reveal>
      <Link
        to={to}
        data-testid={`next-chapter-${to.replace(/\//g, "")}`}
        className="group inline-flex items-center gap-2 bg-burnt hover:bg-burnt-hover text-white font-medium px-8 py-4 text-base md:text-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-burnt focus-visible:ring-offset-2 focus-visible:ring-offset-ink-base"
      >
        {label}
        <ArrowRight
          size={18}
          className="transition-transform group-hover:translate-x-1"
        />
      </Link>
    </Reveal>
  </div>
);

export default NextChapter;
